<template>
  <div>
    <div v-if="visivel()" fluid class="d-flex justify-center align-center flex-column mb-6">
      <div class="pa-2">
        <v-img
          src="@/assets/empty-state.jpg"
          transition="fade"
          max-width="300"
          style="opacity: 0.4"
        ></v-img>
      </div>
      <div class="pa-2 font-weight-light">Nenhuma aula cadastrada para mostrar!</div>
    </div>
    <v-col v-else cols="12">
      <div class="text-center text-h5 font-weight-light">
        <strong>LISTA DE AULAS</strong>
      </div>
    </v-col>
    <v-list>
      <v-list-item v-for="item in classList.classes" :key="item.id">
        <v-row class="pa-0 ma-0">
          <v-list-item-content class="pa-1">
            <v-card class="d-flex pa-0" outlined>
              <div class="float-top">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-if="item.classType == $tipoAula('COLETIVAS')"
                      color="purple"
                      v-bind="attrs"
                      v-on="on"
                    >mdi-bookmark</v-icon>
                    <v-icon v-else color="pink" v-bind="attrs" v-on="on">mdi-bookmark</v-icon>
                  </template>
                  <span v-if="item.classType == $tipoAula('COLETIVAS')">Coletiva</span>
                  <span v-else>Musculação</span>
                </v-tooltip>
              </div>

              <v-col>
                <div>
                  <span class="text-caption">Aula</span>
                  <h4>{{ item.name }}</h4>
                </div>
              </v-col>
              <v-col>
                <div>
                  <span class="text-caption">Horários</span>
                  <h4
                    v-if="item.classSchedules.length == 0"
                    class="red--text"
                  >{{ item.classSchedules.length }}</h4>
                  <h4 v-else>{{ item.classSchedules.length }}</h4>
                </div>
              </v-col>
              <v-col class="d-none d-sm-flex">
                <div>
                  <span class="text-caption">Cap. máx/Aula</span>
                  <h4>{{ item.maxCapacity }}</h4>
                </div>
              </v-col>
              <v-col>
                <v-row class="text-left align-center">
                  <span class="text-caption mr-2">Ativa?</span>
                  <v-switch v-model="item.isActive" dense height="0" class="m-0 p-0" readonly></v-switch>
                </v-row>
              </v-col>
              <v-col class="d-none d-sm-flex">
                <v-row class="text-left align-center">
                  <span class="text-caption mr-2">Pode Reservar?</span>
                  <v-switch v-model="item.allowsSchedule" dense height="0" class="m-0 p-0" readonly></v-switch>
                </v-row>
              </v-col>
              <v-card-actions>
                <v-btn icon @click="editClass(item.id)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-divider vertical class="ml-2 mr-2"></v-divider>
                <v-btn icon @click="deleteClass(item)">
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-list-item-content>
        </v-row>
      </v-list-item>
    </v-list>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data: () => ({}),
  methods: {
    ...mapActions("showClass", [
      "ActionSetShowClassDialog",
      "ActionShowEditClassDialog",
      "ActionDeleteClass"
    ]),
    ...mapActions("snackbar", ["ActionSetSnackbar"]),
    ...mapActions("units", ["ActionFindClassList"]),

    async deleteClass(gymClass) {
      try {
        await this.ActionDeleteClass(gymClass);
        this.ActionSetSnackbar({
          color: "success",
          text: "Parabéns, excluído com sucesso!",
          timeout: 1000
        });
      } catch (error) {
        this.ActionSetSnackbar({
          color: "error",
          text: "Oops, ocorreu alguma falha ao excluir!",
          timeout: 2000
        });
        console.error(error);
      } finally {
        this.refresh();
      }
    },
    refresh() {
      const { name } = this.$route;
      console.log("refresh", name);
      if (name === "home/registered-classes") {
        return this.ActionFindClassList(this.currentUnit);
      }
    },
    editClass(id) {
      this.ActionShowEditClassDialog(id);
    },
    visivel() {
      if (this.classList == null) return true;
      if (this.classList.classes == null) return true;
      if (this.classList.classes.length == 0) return true;
      return false;
    }
  },
  mounted() {
    this.refresh();
  },
  computed: {
    ...mapState("units", ["classList", "currentUnit"])
  }
};
</script>
